import React from 'react';
import DetailsTable from '../../../../Table/DetailsTable';
import { CommandBarButton, IconButton } from '@fluentui/react';
import FeatureSummary from '../../../../Util/FeatureSummary';

const AffinityGroupsTable = ({
    affinityGroups,
    setSelectedAffinityGroup,
    loading,
    editOnClick,
    previewOnClick,
    createOnClick,
    deleteOnClick,
}) => {
    const columns = [
        {
            name: 'Id',
            fieldName: 'affinityGroupSettingId',
            minWidth: 80,
            maxWidth: 120,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu editOnClick={editOnClick} previewOnClick={previewOnClick} id={item.affinityGroupSettingId} item={item} deleteOnClick={deleteOnClick} />
            ),
        },
        {
            name: 'Slug',
            fieldName: 'slug',
            minWidth: 150,
            maxWidth: 200,
            isResizable: true,
        },
        {
            name: 'Header',
            fieldName: 'homeHeroHeader',
            minWidth: 200,
            maxWidth: 300,
            isResizable: true,
        },
        {
            name: 'Topic',
            fieldName: 'conTagID',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
        },
    ];

    const items = affinityGroups ?? [];

    const selectionHook = (items) => {
        setSelectedAffinityGroup && setSelectedAffinityGroup(items && items[0] && items[0].affinityGroupSettingId);
    };

    return (
        <>
            <DetailsTable
                items={items}
                columns={columns}
                selectionHook={selectionHook}
                loading={loading}
                mainColumn={'Header'}
                style={{
                    position: 'relative',
                    height: '80vh',
                    width: '80vw',
                }}
                CommandBar={
                    <CommandBarButton
                        iconProps={{ iconName: 'Edit' }}
                        text="Add Affinity Group"
                        onClick={() => createOnClick()}
                    />
                }
            />
            <FeatureSummary
                label="About Affinity Groups"
                summary="This table displays all affinity group pages, including their slug, header, and topic. You can add, edit, or delete them. The feature allows admins to create themed or tag related pages. The pages follow a similar layout as our logged out home pages."
                imageUrlPath='afinity1'            
            />
        </>
    );
};

const moreIcon = { iconName: 'More' };

const ContextualMenu = ({ editOnClick, deleteOnClick, id, item, ...rest }) => {
    const menuProps = {
        items: [
            {
                key: 'print',
                iconProps: { iconName: 'Edit' },
                text: 'Edit',
                onClick: () => editOnClick(id),
            },
            {
                key: "Delete",
                iconProps: { iconName: "Delete" },
                text: "Delete",
                onClick: () => deleteOnClick(id, item?.homeHeroHeader || item?.header || item?.name || item?.slug || ""),
            },
        ],
    };

    return <IconButton iconProps={moreIcon} menuProps={menuProps} onRenderMenuIcon={() => {}} {...rest} />;
};

export default AffinityGroupsTable;
